import { render, staticRenderFns } from "./DetalhesHistoricoEvento.vue?vue&type=template&id=1d2e1053"
import script from "./DetalhesHistoricoEvento.vue?vue&type=script&lang=ts"
export * from "./DetalhesHistoricoEvento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports